<template>
  <v-card flat>
    <v-overlay :value="isLoading()">
      <v-progress-circular indeterminate size="100" />
    </v-overlay>
    <v-card-text>
      <my-bread-crumbs />
      <show-rob-dr v-if="affichage.rob === 'tab-1'" :items="robs" />
      <show-rob-structure v-if="affichage.rob === 'tab-2'" />
      <show-rob-carte v-if="affichage.rob === 'tab-3'" />
      <show-carte-ligne v-if="affichage.rob === 'tab-4'" />
    </v-card-text>
  </v-card>
</template>

<script>
import { userMixin } from "@/mixins/user";
import { robMixin } from "@/mixins/rob";
import { generalMixin } from "@/mixins/general";

import showRobDr from "@/components/showRobDr";
import showRobStructure from "@/components/showRobStructure";
import showRobCarte from "@/components/showRobCarte";
import showCarteLigne from "@/components/showCarteLigne";
import myBreadCrumbs from "@/components/core/myBreadCrumbs";
import { mapActions, mapGetters } from "vuex";
import { tvaMixin } from "@/mixins/tva";
import { structureMixin } from "@/mixins/structure";
import { ligneRobMixin } from "@/mixins/ligneRob";
import { commandeMixin } from "@/mixins/commande";
import { carteMixin } from "@/mixins/carte";

export default {
  name: "VueRob",
  components: {
    showRobDr,
    showRobStructure,
    showRobCarte,
    showCarteLigne,
    myBreadCrumbs,
  },
  mixins: [
    userMixin,
    robMixin,
    generalMixin,
    tvaMixin,
    structureMixin,
    ligneRobMixin,
    commandeMixin,
    carteMixin,
  ],
  computed: {
    ...mapGetters({
      robCartesIsLoading: "carte/robList/isLoading",
      commandesIsLoading: "commande/list/isLoading",
      commandesNoCaIsLoading: "commande/listNoCa/isLoading",
      ligneRobsIsLoading: "ligneRob/list/isLoading",
      relanceIsLoading: "relance/list/isLoading",
      relanceCreateIsLoading: "relance/create/isLoading",
      robsIsLoading: "rob/list/isLoading",
      robIsLoading: "rob/show/isLoading",
      structuresIsLoading: "structure/list/isLoading",
      structureIsLoading: "structure/show/isLoading",
      userIsLoading: "user/current/isLoading",
      createLinkIsLoading: "link/create/isLoading",
      ligneRobUpdateIsLoading: "ligneRob/update/isLoading",
      ligneRobStructureIsLoading: "ligneRob/listStruct/isLoading",
      userCreateIsLoading: "user/create/isLoading",
      tvaIsLoading: "tva/list/isLoading",
      typeRelancesIsLoading: "typeRelance/list/isLoading",
      sendIsLoading: "relance/send/isLoading",
      robUpdateIsloading: "rob/update/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getTypeRelances: "typeRelance/list/getItems",
    }),
    isLoading() {
      return (
        this.robCartesIsLoading ||
        this.commandesIsLoading ||
        this.ligneRobsIsLoading ||
        this.relanceIsLoading ||
        this.relanceCreateIsLoading ||
        this.robsIsLoading ||
        this.robIsLoading ||
        this.structuresIsLoading ||
        this.structureIsLoading ||
        this.userIsLoading ||
        this.createLinkIsLoading ||
        this.ligneRobUpdateIsLoading ||
        this.ligneRobStructureIsLoading ||
        this.commandesNoCaIsLoading ||
        this.userCreateIsLoading ||
        this.tvaIsLoading ||
        this.typeRelancesIsLoading ||
        this.sendIsLoading ||
        this.robUpdateIsloading
      );
    },
    evalParams() {
      if (
        this.$route.params.rob !== undefined &&
        this.$route.params.structure !== undefined &&
        this.$route.params.ligne !== undefined &&
        this.$route.params.carte !== undefined &&
        this.$route.params.centre_facturation !== undefined &&
        this.$route.params.nomStructure !== undefined
      ) {
        this.paramsRob.robId = this.$route.params.rob;
        this.paramsRob.structureId = this.$route.params.structure;
        this.paramsRob.carteId = this.$route.params.carte;
        this.paramsRob.ligneId = this.$route.params.ligne;
        this.breadCrumbs.rob = this.$route.params.centre_facturation;
        this.breadCrumbs.structure = this.$route.params.nomStructure;
        this.breadCrumbs.carte = this.$route.params.nomCarte;

        delete this.$route.params.rob;
        delete this.$route.params.structure;
        delete this.$route.params.carte;
        delete this.$route.params.centre_facturation;
        delete this.$route.params.nomCarte;
        delete this.$route.params.ligne;
        delete this.$route.params.nomStructure;
        this.getligneRobs({
          robId: this.paramsRob.robId,
          carteId: this.paramsRob.carteId,
        });
        this.getCommandes(this.paramsRob.structureId);
        this.getCommandesNoCa(this.paramsRob.structureId);
        this.affichage.rob = "tab-4";
      }
    },
  },
  updated() {
    this.evalParams();
  },
  mounted() {
    this.getRobs();
    this.evalParams();
    this.getTypeRelances();
  },
};
</script>

<style scoped>
.backgroud_image {
  background-color: indigo;
}
</style>
